import { render, staticRenderFns } from "./Spirit.vue?vue&type=template&id=20a3424a&scoped=true&"
import script from "./Spirit.vue?vue&type=script&lang=js&"
export * from "./Spirit.vue?vue&type=script&lang=js&"
import style0 from "./Spirit.vue?vue&type=style&index=0&id=20a3424a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a3424a",
  null
  
)

export default component.exports